import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="writablestreamdefaultwriter" id="writablestreamdefaultwriter"></a>
    <h1 {...{
      "id": "windowwritablestreamdefaultwriter"
    }}>{`window.WritableStreamDefaultWriter`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/WritableStreamDefaultWriter"
      }}>{`Web APIs - WritableStreamDefaultWriter`}</a>{`  `}</p>
    <a name="new-writablestreamdefaultwriter-new" id="new-writablestreamdefaultwriter-new"></a>
    <h2 {...{
      "id": "writablestreamdefaultwriterstream"
    }}>{`WritableStreamDefaultWriter(stream)`}</h2>
    <p>{`Creates a new WritableStreamDefaultWriter object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`WritableStreamDefaultWriter`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`stream`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`WritableStream`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="writablestreamdefaultwriter-closed" id="writablestreamdefaultwriter-closed"></a>
    <h2 {...{
      "id": "closed--promisevoid"
    }}>{`closed : `}<inlineCode parentName="h2">{`Promise<void>`}</inlineCode></h2>
    <p>{`Returns a Promise that fullfils if the stream becomes closed,
or rejects if the stream errors or the writer's lock is released.`}</p>
    <a name="writablestreamdefaultwriter-desiredsize" id="writablestreamdefaultwriter-desiredsize"></a>
    <h2 {...{
      "id": "desiredsize--number"
    }}>{`desiredSize : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The desired size required to fill the stream's internal queue.
It will return null if the stream cannot be successfully written to.
It will return zero if the stream is closed.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the writer's lock is released.`}</li>
    </ul>
    <a name="writablestreamdefaultwriter-ready" id="writablestreamdefaultwriter-ready"></a>
    <h2 {...{
      "id": "ready--promisevoid"
    }}>{`ready : `}<inlineCode parentName="h2">{`Promise<void>`}</inlineCode></h2>
    <p>{`Returns a Promise that resolves when the desired size of the stream's internal queue transitions
from non-positive to positive, signaling that it is no longer applying backpressure.
Once the desired size dips back to zero or below, the getter will return a new promise that stays pending until the next transition.
If the stream becomes errored or aborted, or the writer’s lock is released, the returned promise will become rejected.`}</p>
    <a name="writablestreamdefaultwriter-abort" id="writablestreamdefaultwriter-abort"></a>
    <h2 {...{
      "id": "abortreason"
    }}>{`abort(reason)`}</h2>
    <p>{`Aborts the stream, signaling that the producer can no longer successfully write to the stream
and it is to be immediately moved to an errored state, with any queued-up writes discarded.
The returned promise will fulfill if the stream shuts down successfully, or reject if the underlying sink signaled that there was an error doing so.
It will reject with a TypeError if the stream is curretly locked.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the stream is not a WritableStream, or it is locked.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="writablestreamdefaultwriter-close" id="writablestreamdefaultwriter-close"></a>
    <h2 {...{
      "id": "close"
    }}>{`close()`}</h2>
    <p>{`Closes the stream and returns a Promise that will fulfill if all remaining chunks are successfully written
and the stream successfully closes, or rejects if an error is encountered during this process.
It will reject with a TypeError (without attempting to cancel the stream) if the stream is currently locked.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{`  `}</p>
    <a name="writablestreamdefaultwriter-releaselock" id="writablestreamdefaultwriter-releaselock"></a>
    <h2 {...{
      "id": "releaselock"
    }}>{`releaseLock()`}</h2>
    <p>{`Releases the writer’s lock on the corresponding stream. After the lock is released, the writer is no longer active.
If the associated stream is errored when the lock is released, the writer will appear errored in the same way from now on;
otherwise, the writer will appear closed.`}</p>
    <a name="writablestreamdefaultwriter-write" id="writablestreamdefaultwriter-write"></a>
    <h2 {...{
      "id": "writechunk"
    }}>{`write(chunk)`}</h2>
    <p>{`Writes the given chunk to the writable stream and its underlying sink,
then returns a Promise that resolves to indicate the success or failure of the write operation.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the stream is not a writable stream, or it does not have an owner.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`chunk`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      